// tslint:disable:class-name

import { Translation } from "primeng/api";

export class HTTP_CONTENT_HEADERS {
  public static Zip = "application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip";
  public static Excel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  public static Pdf = "application/pdf";
  public static Json = "application/json";
  public static Word = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
}

export class GLOBAL_VARIABLES {
  public static REGEXP_URL = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  public static REGEXP_LINK = /^(http|https|ftp)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(:[a-zA-Z0-9]*)?\/?([a-zA-Z0-9\-\._\?\,\'\/\\\+&\%\$#\=~])*[^\.\,\)\(\s]$/;
  public static REGEXP_EMAIL = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  public static REGEXP_DATE = /^\s*(3[01]|[12][0-9]|0?[1-9])\-(1[012]|0?[1-9])\-((?:19|20)\d{2})\s*$/;
  public static REGEXP_PHONE = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
  public static REGEXP_PHONE_ANOTHER = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
  public static REGEXP_LATITUDE = /^(\\+|-)?(?:90(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,6})?))$/;
  public static REGEXP_LONGITUDE = /^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$/;
  public static CALENDAR_RU = {
    firstDayOfWeek: 1,
    dayNames: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    dayNamesShort: ["ВОС", "ПОН", "ВТО", "СРЕ", "ЧЕТ", "ПЯТ", "СУБ"],
    dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    today: 'Сегодня',
    clear: 'Очистить',
    dateFormat: 'dd-mm-yy',
    weekHeader: 'Н'
  };
  public static TINY_MCE_INIT_PROPS = {
    language: 'ru',
    height: 400,
    menubar: 'file edit view insert format tools table help',
    toolbar_sticky: true,
    toolbar_mode: 'sliding' as 'sliding',
    base_url: '/tinymce', // Root for resources
    suffix: '.min' ,       // Suffix to use when loading resources
    promotion: false,
    // plugins: ["fullscreen", "autolink"],
    plugins: [
'print', 'preview', 'paste', 'importcss', 'searchreplace', 'autolink', 'save',
'directionality', 'code', 'visualblocks', 'visualchars', 'fullscreen', 'image',
'link', 'media', 'codesample', 'table', 'charmap', 'hr', 'pagebreak', 'nonbreaking', 'anchor',
'toc', 'insertdatetime', 'advlist', 'lists', 'wordcount', 'imagetools', 'textpattern',
'noneditable', 'help', 'charmap', 'quickbars', 'emoticons'
    ],
    toolbar:
      'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | \
      alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
      forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | \
      insertfile image media link anchor codesample | ltr rtl'
  };


  public static TINY_MCE_INIT_PROPS_MINI = {
    language: 'ru',
    height: 250,
    menubar: '',
    toolbar_sticky: true,
    toolbar_mode: 'sliding' as 'sliding',
    base_url: '/tinymce', // Root for resources
    suffix: '.min' ,       // Suffix to use when loading resources
    plugins: [ 'fullscreen' ],
    promotion: false,
    toolbar:
      'undo redo | bold italic underline strikethrough |  subscript superscript | \
      alignleft aligncenter alignright alignjustify   numlist bullist | \
       removeformat | charmap | fullscreen ',
  };

  public static TINY_MCE_INIT_PROPS_TITLE = {
    language: 'ru',
    height: 150,
    menubar: '',
    toolbar_sticky: true,
    toolbar_mode: 'sliding' as 'sliding',
    base_url: '/tinymce', // Root for resources
    suffix: '.min' ,       // Suffix to use when loading resources
    promotion: false,
    toolbar:
      'undo redo | bold italic underline | subscript superscript '
  };

  public static TINY_MCE_INIT_PROPS_MINI_NOFULLSCREEN = {
    language: 'ru',
    height: 250,
    menubar: '',
    toolbar_sticky: true,
    toolbar_mode: 'sliding' as 'sliding',
    base_url: '/tinymce', // Root for resources
    suffix: '.min' ,       // Suffix to use when loading resources
    plugins: [ 'fullscreen' ],
    promotion: false,
    toolbar:
      'undo redo | bold italic underline strikethrough | subscript superscript | \
      alignleft aligncenter alignright alignjustify   numlist bullist | \
       removeformat | charmap  '
  };

  public static PRIMENG_RU: Translation = {
    "startsWith": "Начинается с",
    "contains": "Содержит",
    "notContains": "Не содержит",
    "endsWith": "Оканчивается на",
    "equals": "Равен",
    "notEquals": "Не равен",
    "noFilter": "Фильтр не задан",
    "lt": "Менее",
    "lte": "Не более",
    "gt": "Более",
    "gte": "Не менее",
    "is": "Is",
    "isNot": "Is not",
    "before": "До",
    "after": "После",
    "clear": "Очистить",
    "apply": "Применить",
    "matchAll": "Полное совпадение",
    "matchAny": "Любое совпадение",
    "addRule": "Добавить правило",
    "removeRule": "Удалить правило",
    "accept": "Да",
    "reject": "Нет",
    "choose": "Выберите",
    "upload": "Загрузить",
    "cancel": "Отмена",
    "dayNames": ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четсверг", "Пятница", "Суббота"],
    "dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    "dayNamesMin": ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
    "monthNames": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    "monthNamesShort": ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    "today": "Сегодня",
    "weekHeader": "Нед",
    "weak": 'Weak',
    "medium": 'Medium',
    "strong": 'Strong',
    "passwordPrompt": 'Enter a password',
    "emptyMessage": 'Не найдено',
    "emptyFilterMessage": 'Не выбрано'
}

  public static COLORS = [
    '#7FFFD4',
    '#000000',
    '#FFEBCD',
    '#0000FF',
    '#8A2BE2',
    '#A52A2A',
    '#5F9EA0',
    '#7FFF00',
    '#D2691E',
    '#6495ED',
    '#DC143C',
    '#00FFFF',
    '#00008B',
    '#008B8B',
    '#B8860B',
    '#A9A9A9',
    '#006400',
    '#BDB76B',
    '#8B008B',
    '#556B2F',
    '#FF8C00',
    '#9932CC',
    '#8B0000',
    '#E9967A',
    '#8FBC8F',
    '#483D8B',
    '#2F4F4F',
    '#00CED1',
    '#9400D3',
    '#FF1493',
    '#00BFFF',
    '#696969',
    '#1E90FF',
    '#B22222',
    '#228B22',
    '#808080',
    '#FF00FF',
    '#FFD700',
    '#DAA520',
    '#008000',
    '#ADFF2F',
    '#808080',
    '#FF69B4',
    '#CD5C5C',
    '#4B0082',
    '#F0E68C',
    '#7CFC00',
    '#FFFACD',
    '#ADD8E6',
    '#F08080',
    '#FAFAD2',
    '#90EE90',
    '#FFB6C1',
    '#FFA07A',
    '#20B2AA',
    '#87CEFA',
    '#778899',
    '#B0C4DE',
    '#32CD32',
    '#FF00FF',
    '#800000',
    '#66CDAA',
    '#BA55D3',
    '#9370DB',
    '#3CB371',
    '#7B68EE',
    '#00FA9A',
    '#48D1CC',
    '#C71585',
    '#FFDEAD',
    '#000080',
    '#000000',
    '#808000',
    '#6B8E23',
    '#FFA500',
    '#FF4500',
    '#DA70D6',
    '#EEE8AA',
    '#98FB98',
    '#AFEEEE',
    '#DB7093',
    '#FFDAB9',
    '#CD853F',
    '#FFC0CB',
    '#DDA0DD',
    '#B0E0E6',
    '#800080',
    '#FF0000',
    '#BC8F8F',
    '#4169E1',
    '#8B4513',
    '#FA8072',
    '#F4A460',
    '#2E8B57',
    '#A0522D',
    '#C0C0C0',
    '#87CEEB',
    '#708090',
    '#00FF7F',
    '#4682B4',
    '#D2B48C',
    '#D8BFD8',
    '#FF6347',
    '#008080',
    '#9ACD32'].reverse();

}

export class ABSTRACT_STATUS_ENUM {
  public static readonly NEW: string = 'Новый';
  public static readonly AT_WORK: string = 'В работе';
  public static readonly MODIFICATION: string = 'Доработка';
  public static readonly ACCEPTED: string = 'Принят';
  public static readonly REJECTED: string = 'Отклонён';
  public static readonly REJECTED_AGAIN: string = 'Отклонён повторно';
  public static readonly RESPONSE_RECEIVED: string = 'Получен ответ';
}

export class ENUM_INCOMING_CHANNELS {
  public static readonly PARAM_NAME = "channel";
  public static readonly DEFAULT = "online";
  public static readonly ONLINE = "online";
  public static readonly OFFLINE = "offline";
  public static readonly WEBINAR = "webinar";

  public static readonly ALL = [ENUM_INCOMING_CHANNELS.ONLINE, ENUM_INCOMING_CHANNELS.OFFLINE, ENUM_INCOMING_CHANNELS.WEBINAR];
}

export class ENUM_EMAIL_TYPES
{
    public static readonly NMO = "NMO";
    public static readonly INVITATION = "INVITATION";
    public static readonly ONLINEREG = "ONLINEREG";
    public static readonly FAIL_LIMIT = 3;
}
